import { capitalizeString } from './stringHelper';

class SubtitlesHelper {
  /**
   * Find the original subtitles
   *
   * @param {array} subtitlesMeta Array of subtitles objects
   * @returns `object` when found, else `undefined`
   */
  static getSubtitlesFromMetadata(subtitlesMeta, original, trimmed) {
    if (subtitlesMeta.length > 0) {
      return subtitlesMeta.find(obj => {
        return obj.original == original && obj.trimmed == trimmed;
      });
    } else {
      return undefined;
    }
  }

  static appendMarginYForOrientation(subtitlesSettings, orientation) {
    let result = null;
    if (subtitlesSettings) {
      const marginY = subtitlesSettings['marginY' + capitalizeString(orientation ?? 'landscape')];
      result = { ...subtitlesSettings, marginY };
    }

    return result;
  }
}

export default SubtitlesHelper;
